import React, { useEffect, useState } from 'react';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import './EventDetails.scss';
import {
    Column,
    DataGrid,
    Editing
} from 'devextreme-react/data-grid';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { getApiToken } from '../../../utils/authUtils.js';
import { useMsal } from "@azure/msal-react";
import { EditCellTimeComponent, TimeBox } from '../../utils/time-box/TimeBox.js';
import { GENDERS } from '../../../shared/constants.js';
import { checkPermission } from '../../../permissions.js';

export const EventDetails = (props) => {
    const { instance, accounts } = useMsal();
    const [eventAgegroupsStore, setEventAgegroupsStore] = useState(null);
    const [eventTimelimitsStore, setEventTimelimitsStore] = useState(null);

    useEffect(() => {
        if (props.data.key) {
            getApiToken(instance, accounts).then((token) => {
                // Store für EventAgegroups
                setEventAgegroupsStore({
                    store: createStore({
                        key: 'eventAgegroupId',
                        loadUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/EventAgegroups`,
                        insertUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/InsertEventAgegroup`,
                        updateUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/UpdateEventAgegroup`,
                        deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/DeleteEventAgegroup`,
                        onBeforeSend: (method, ajaxOptions) => {
                            ajaxOptions.headers = {
                                'Authorization': "Bearer " + token
                            };
                        },
                    }),
                    filter: ['eventId', '=', props.data.data.eventId]
                });

                // Store für EventTimelimits  
                setEventTimelimitsStore({
                    store: createStore({
                        key: 'timestandardId',
                        loadUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/EventTimestandards`,
                        insertUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/InsertEventTimestandard`,
                        updateUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/UpdateEventTimestandard`,
                        deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/DeleteEventTimestandard`,
                        onBeforeSend: (method, ajaxOptions) => {
                            ajaxOptions.headers = {
                                'Authorization': "Bearer " + token
                            };
                        },
                    }),
                    filter: ['eventId', '=', props.data.data.eventId]
                });
            });
        }
    }, [props.data.key, props.data.data.eventId, instance, accounts]);

    return (
        <TabPanel height={300}>
            <Item title="Altersklassen">
                <div className='event-details-grid'>
                    <DataGrid
                        dataSource={eventAgegroupsStore}
                        showBorders={true}
                        remoteOperations={true}
                        height={250}
                        columnAutoWidth={true}
                    >
                        <Editing allowUpdating={checkPermission("competition.edit")} allowAdding={checkPermission("competition.edit")} allowDeleting={checkPermission("competition.edit")} />
                        <Column dataField="description" caption='Beschreibung' />
                        <Column
                            dataField="dateofbirthmin"
                            caption='von'
                            dataType='date'
                            format='yyyy'
                               sortOrder='asc'
                            sortIndex={0}
                        />
                        <Column
                            dataField="dateofbirthmax"
                            caption='bis'
                            dataType='date'
                            format='yyyy'
                        />
                    </DataGrid>
                </div>
            </Item>
            <Item title="Pflicht-/Richtzeiten">
                <div className='event-details-grid'>
                    <DataGrid
                        dataSource={eventTimelimitsStore}
                        showBorders={true}
                        remoteOperations={true}
                        height={250}
                        columnAutoWidth={true}
                    >
                        <Editing allowUpdating={checkPermission("competition.edit")} allowAdding={checkPermission("competition.edit")} allowDeleting={checkPermission("competition.edit")} />
                        <Column
                            dataField="dateofbirthmin"
                            caption='von'
                            dataType='date'
                            format='yyyy'
                            sortOrder='asc'
                            sortIndex={0}
                        />
                        <Column
                            dataField="dateofbirthmax"
                            caption='bis'
                            dataType='date'
                            format='yyyy'
                        />
                        <Column
                            dataField="swimtime"
                            caption='Zeitlimit'
                            dataType='number'
                            cellRender={TimeBox}
                             editCellComponent={EditCellTimeComponent}
                        />
                    </DataGrid>
                </div>
            </Item>
        </TabPanel>
    );
};